import { moneyFormat } from '@/components/helpers/formats'

/** Formats pence from the donor API as a GBP display string (e.g. £1,234.56). */
export function formatMoneyFromPence(pence: number): string {
  const formatted = moneyFormat(pence)
  return formatted ? `£${formatted}` : '£0.00'
}

/**
 * Pounds and pence for an HMRC Self Assessment box. Online fields show the
 * pound sign for you, so this is digits and a decimal only, with no commas.
 */
export function formatHmrcAmountFromPence(pence: number): string {
  return (pence / 100).toFixed(2)
}
